define('lq/layouting',[],function () {
    'use strict';

    var cssRules = undefined;

    var applyLayout = function ($target, currentLayout) {
        $target
            .removeClass(function (index, className) {
                return className.lastIndexOf('using-layout-', 0) !== 0;
            });

        if (!currentLayout) return;

        $target
            .addClass('with-layout using-layout-' + currentLayout.id);

        if (!cssRules) {
            cssRules = document.createElement('style');
            document.body.appendChild(cssRules);
        }

        cssRules.innerHTML = '.with-layout.using-layout-' + currentLayout.id +
            ' .layout-specific:not(.supports-layout-' + currentLayout.id + ') {' +
            '   display: none !important;' +
            '}\n' +
            '.with-layout.using-layout-' + currentLayout.id +
            ' *:has(> .layout-specific:not(.supports-layout-' + currentLayout.id + ')) {' +
            '   padding: 0 !important;' +
            '}';
    };

    return {

        applyLayout: applyLayout

    };

});
